import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface AuctionsLocationsObject {
  id: number;
  titleEn: string;
  titleAr: string;
  isActive: boolean;
}

export interface AuctionsLocationsListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  types: Array<AuctionsLocationsObject>;
  errors: unknown;
}

@Module
export default class AuctionsLocationsModule
  extends VuexModule
  implements AuctionsLocationsListInfo
{
  types = [] as Array<AuctionsLocationsObject>;
  allTypes = [] as Array<AuctionsLocationsObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get types list
   * @returns Array<AuctionsLocationsObject>
   */
  get auctionLocationsList(): Array<AuctionsLocationsObject> {
    return this.types;
  }

  /**
   * Get all types list
   * @returns Array<PropertyTypeObject>
   */
  get allAuctionsLocationsList(): Array<AuctionsLocationsObject> {
    return this.allTypes;
  }

  /**
   * Get total items
   * @returns number
   */
  get auctionLocationsListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_AUCTION_LOCATIONS](data) {
    this.types = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_ALL_AUCTION_LOCATIONS](data) {
    this.allTypes = data.data;
  }

  @Mutation
  [Mutations.RESET_AUCTION_LOCATIONS_LIST]() {
    this.types = [] as Array<AuctionsLocationsObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  // @Mutation
  // [Mutations.SET_ALL_AUCTION_PROPERTY_TYPES](data) {
  //   this.allTypes = data.data;
  // }

  @Mutation
  [Mutations.SET_AUCTION_PROPERTY_TYPE_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.SET_AUCTION_LOCATIONS_CURRENT_PAGE]() {
    this.types = [] as Array<AuctionsLocationsObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.CREATE_AUCTION_LOCATION](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/auctions-locations', data)
      .then(() => {
        this.context.commit(Mutations.SET_AUCTION_LOCATIONS_CURRENT_PAGE);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_AUCTION_LOCATION](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/auctions-locations', id)
      .then(() => {
        this.context.commit(Mutations.SET_AUCTION_LOCATIONS_CURRENT_PAGE);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_AUCTION_LOCATION]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/auctions-locations', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_AUCTION_LOCATIONS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_AUCTION_LOCATIONS_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_AUCTION_PROPERTY_TYPE_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_AUCTION_LOCATION](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/auctions-locations', id);
  }

  @Action
  [Actions.GET_AUCTION_LOCATIONS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/auctions-locations', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUCTION_LOCATIONS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.GET_ALL_AUCTION_LOCATIONS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/auctions-locations/all')
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ALL_AUCTION_LOCATIONS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
}
